import styled from "styled-components"

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0px 15px;
  height: 70px;
  width: 100%;

  background: ${(props) => props.theme.colors.text};

  img {
    height: 60px;
    width: 60px;

    cursor: pointer;
  }

  p {
    display: flex;
    flex-direction: column;

    font-size: 18px;

    color: ${(props) => props.theme.colors.white};

    a {
      text-decoration: none;
      color: ${(props) => props.theme.colors.contrastOrange};
      font-weight: 500;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`
